export const MODULES = {
  FEEDBACK: 'FEEDBACK',
  HIRING: 'HIRING',
  OMBUDSMAN: 'OMBUDSMAN',
  OMBUDSMAN_EXTERNAL: 'OMBUDSMAN_EXTERNAL',
  PLANNING: 'PLANNING',
  GOALS: 'GOALS',
  PERMISSIONS: 'PERMISSIONS',
  TEMP: 'TEMP',
  TEST: 'TEST',
};
